/* eslint-disable import/no-duplicates */
import React from 'react';
import PropTypes from 'prop-types';
import LegendIcon from 'components/legend-icon';
import SvgText from 'components/svg-text';
import * as Mask from 'constants/mask';
import {BAR_SERIES} from 'constants/series-type';
import {BAR_STEP_SERIES} from 'constants/series-type';
import {CLUSTERED_COLUMN_SERIES} from 'constants/series-type';
import {COLUMN_SERIES} from 'constants/series-type';
import {COLUMN_STEP_SERIES} from 'constants/series-type';
import {DIFFERENCE_BAR_SERIES} from 'constants/series-type';
import {DIFFERENCE_COLUMN_SERIES} from 'constants/series-type';
import {DOT_SERIES} from 'constants/series-type';
import {LINE_SERIES} from 'constants/series-type';
import {STACKED_COLUMN_SERIES} from 'constants/series-type';
import {getTranslate} from 'utils/attribute-util';
import {getCenter} from 'utils/layout-util';
import styles from './index.css';

export default class LegendItem extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    label: PropTypes.string,
    mask: PropTypes.oneOf(Object.values(Mask)),
    style: PropTypes.object,
    type: PropTypes.oneOf([
      BAR_SERIES,
      BAR_STEP_SERIES,
      CLUSTERED_COLUMN_SERIES,
      COLUMN_SERIES,
      COLUMN_STEP_SERIES,
      DIFFERENCE_BAR_SERIES,
      DIFFERENCE_COLUMN_SERIES,
      DOT_SERIES,
      LINE_SERIES,
      STACKED_COLUMN_SERIES,
    ]),
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    height: 14,
    label: '',
    mask: '',
    style: {},
    type: COLUMN_SERIES,
    x: 0,
    y: 0,
  };

  getIconWidth(height) {
    return Math.round(height * 2);
  }

  render() {
    const {x, y} = this.props;
    const centerY = getCenter(this.props.height);
    const iconWidth = this.getIconWidth(this.props.height);
    const spacing = getCenter(this.props.height);
    return (
      <g
        className={styles.LegendItem}
        transform={getTranslate(x > 0 ? x : 0, y > 0 ? y : 0)}>
        <LegendIcon
          height={this.props.height}
          mask={this.props.mask}
          style={this.props.style}
          type={this.props.type}
          width={iconWidth}
        />

        {this.props.label ? (
          <SvgText
            style={{
              dominantBaseline: 'central',
            }}
            text={this.props.label}
            x={iconWidth + spacing}
            y={centerY}
          />
        ) : null}
      </g>
    );
  }
}
